module.exports = __webpack_public_path__ + "img/cbr-quest-vizualization.8ceb7020.svg";